(function () {
  'use strict';

  var source = document.currentScript && document.currentScript.dataset;
  if (!source) return;
  var images = {
    'Necessary Measurements': source.body,
    'Sleeve and Partially Sleeveless Measurements': source.sleeve,
    'Hollow to Hem': source.hem
  };

  function init() {
    document.querySelectorAll('.rte:has(> .common-title)').forEach(function (guide) {
      Array.from(guide.querySelectorAll('img[alt]')).forEach(function (image) {
      var replacement = images[image.alt];
      if (!replacement) return;
      image.removeAttribute('srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.classList.remove('lazyload', 'lazyloading');
      image.src = replacement;
      image.loading = 'eager';
      if (image.alt === 'Necessary Measurements') {
        image.classList.add('cs-guide-basic-image');
        image.width = 1024;
        image.height = 1536;
        if (!source.hips || !source.belly || guide.querySelector('.cs-guide-extra-measurements')) return;
        var extra = document.createElement('div');
        extra.className = 'cs-guide-extra-measurements';
        [
          { src: source.hips, alt: 'Hip and butt measurements: fuller and smaller buttocks, with an upper hips line and a lower butt line. Provide this measurement if your butt is bigger than your hips.' },
          { src: source.belly, alt: 'Waist and belly measurements: the natural waist and a level tape around the fullest abdomen. Provide this measurement if you have a bigger belly.' }
        ].forEach(function (item) {
          var figure = document.createElement('figure');
          var detail = document.createElement('img');
          detail.src = item.src;
          detail.alt = item.alt;
          detail.width = 1536;
          detail.height = 1024;
          detail.loading = 'lazy';
          detail.decoding = 'async';
          figure.appendChild(detail);
          extra.appendChild(figure);
        });
        // Insert outside the original paragraph, never nest block content in <p>.
        (image.closest('p') || image).insertAdjacentElement('afterend', extra);
      }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
